<template>
<div>
    <patent-form ref="patentFormModal"></patent-form>
    <patent-official-deadline-log-form :getPatentOfficialDeadlineLogList="getPatentOfficialDeadlineLogList" ref="patentOfficialDeadlineLogFormModal"></patent-official-deadline-log-form>
    <b-row>
        <b-col class="col-12">
            <div style="float:left;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                    </div>
                </b-form-group>
            </div>
            <div style="float:right;" class="custom-search d-flex justify-content-end">
                <b-form-group>
                    <div class="d-flex align-items-center">
                        <b-button style="float:right;" size="sm" variant="outline-primary" @click="getInfo(0)">{{ $t('others.add') }}</b-button>
                        <b-button style="float:right;" size="sm" variant="outline-primary" v-on:keyup.enter="getPatentOfficialDeadlineLogList()" @click="getPatentOfficialDeadlineLogList()">{{ $t('others.list') }}</b-button>
                        <b-button style="float:right;" size="sm" variant="outline-primary" @click="exportExcel()">{{ $t('excel.excel') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="patentOfficialDeadlineLogReportTable" ref="patentOfficialDeadlineLogReportTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
            enabled: true,
            externalQuery: searchTerm
          }" :select-options="{
            enabled: false,
            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
            selectionInfoClass: 'custom-class',
            selectionText: 'rows selected',
            clearSelectionText: 'clear',
            disableSelectInfo: true, // disable the select info panel on top
            selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
          }" :pagination-options="{
            enabled: true,
            perPage: pageLength
          }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'recordNo'" class="text-nowrap">
                {{ $t('patentOfficialDeadlineLogReport.record_no') }}
            </span>
            <span v-else-if="props.column.field === 'deadlineDate'" class="text-nowrap">
                {{ $t('patentOfficialDeadlineLogReport.deadline_date') }}
            </span>
            <span v-else-if="props.column.field === 'remainingDays'" class="text-nowrap">
                {{ $t('patentOfficialDeadlineLogReport.remaining_days') }}
            </span>
            <span v-else-if="props.column.field === 'note'" class="text-nowrap">
                {{ $t('patentOfficialDeadlineLogReport.note') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
                {{ $t('others.process') }}
            </span>
        </template>
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'process'">
                <span>
                    <b-button v-b-tooltip.html :title="$t('others.edit')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getInfo(props.row.id)">
                        <feather-icon icon="EditIcon" />
                    </b-button>
                </span>
                <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1" size="sm" @click="deleted(props.row)">
                    <feather-icon icon="XIcon" />
                </b-button>
                <span>
                    <b-button v-b-tooltip.html :title="$t('patentOfficialDeadlineLogReport.patent_info')" v-b-modal.modal-top variant="primary" class="btn-icon mb-1 ml-1" size="sm" @click="getPatentInfo(props.row.patentId)">
                        <feather-icon icon="EyeIcon" />
                    </b-button>
                </span>
            </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
                    </span>
                    <b-form-select v-model="pageLength" :options="['10', '50', '100', '1000']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [{
                    label: this.$t('patentOfficialDeadlineLogReport.record_no'),
                    field: `recordNo`,
                },
                {
                    label: this.$t('patentOfficialDeadlineLogReport.deadline_date'),
                    field: 'deadlineDate',
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('patentOfficialDeadlineLogReport.official_deadline_date'),
                    field: 'officialDeadlineDate',
                    formatFn: this.$formatFn
                },
                {
                    label: this.$t('patentOfficialDeadlineLogReport.note'),
                    field: 'note'
                },
                {
                    label: this.$t('patentOfficialDeadlineLogReport.remaining_days'),
                    field: 'remainingDays'
                },
                {
                    label: 'Process',
                    field: 'process',
                    width: '16em',
                    sortable: false,
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getPatentOfficialDeadlineLogList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'PatentOfficialDeadlineLog'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getPatentOfficialDeadlineLogList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getPatentOfficialDeadlineLogList()
                        }
                    })
                }
            })
        },
        async getPatentInfo(id) {
            this.$refs.patentFormModal.showInfo(id)
        },
        async getInfo(id) {
            this.$refs.patentOfficialDeadlineLogFormModal.showInfo(id)
        },
        getPatentOfficialDeadlineLogList() {
            this.rows = []
            const controller = {
                name: 'PatentOfficialDeadlineLog',
            }
            const payload = {
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    response.data.patentOfficialDeadlineLogList.forEach(element => {
                        this.rows.push(element)
                    })
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportExcel() {
            const controller = {
                name: 'PatentOfficialDeadlineLog',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("Patent Master Deadline Raporu", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.excel-css {
    float: right;
    margin-right: 1em;
    width: 9.5em;
    color: #7367f0;
    border: 1px solid #7367f0;
    background-color: transparent;
    margin-left: 1em;
    height: 2em;
    border-radius: 0.358rem;
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
